import BaseDatePicker from './BaseDatePicker.vue'
export default {
  extends: BaseDatePicker,
  data() {
    return {
      type: 'datetime'
    }
  }
}
